import './scripts/modernizr';

import pageScrollNavStyle from 'template-parts/navigation';
import bannerTextAreaBlock from '@blocks/banner-textarea';
import listItemHoverEffect from '@blocks/image-list';
import equalCarouselSlideHeights from '@blocks/blog-post-carousel';

declare global {
  interface Window {
    gmak: string; // gmak - Google Maps API Key
    initGoogleMaps: () => void;
    Sentry?: {
      captureException: (e: Error) => void;
    };
  }
}

const initGoogleMaps = (): void => {
  console.log('Initialize Google Maps...');
};

if (window.gmak) {
  window.initGoogleMaps = initGoogleMaps;
  const s = document.createElement('script');
  s.async = true;
  s.defer = true;
  s.src = `https://maps.googleapis.com/maps/api/js?key=${window.gmak}&callback=initGoogleMaps`;
  document.body.appendChild(s);
}

export const docReady: (fn: () => void) => void = (fn) => {
  // see if DOM is already available
  if (
    document.readyState === 'complete' ||
    document.readyState === 'interactive'
  ) {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

docReady(() => {
  document.body.setAttribute('data-load-state', 'loaded');

  // WP Block Quote

  const blockQuote = document.querySelectorAll<HTMLElement>('.wp-block-quote');

  blockQuote.forEach((element) => {
    const style = getComputedStyle(element),
      color = style.color;
    element.style.setProperty('--pipe-color', color);
  });

  [
    pageScrollNavStyle,
    bannerTextAreaBlock,
    listItemHoverEffect,
    equalCarouselSlideHeights,
  ].forEach((fn) => {
    try {
      fn();
    } catch (e) {
      console.error(e);
      try {
        if (
          typeof window.Sentry === 'object' &&
          typeof window.Sentry.captureException === 'function'
        ) {
          window.Sentry.captureException(e);
        }
      } catch (_e) {
        console.error('Failed to send error to Sentry');
        console.error(_e);
      }
    }
  });
});
